import {
    Card,
    Column,
    FlexBox,
    GridContainer,
    Row,
    Typography,
    responsive,
    tokensRaw,
} from '@vp/swan';
import StartingProjectImages from './StartingProjectImages';

const ResponsiveCard = responsive(Card);
const ResponsiveFlexBox = responsive(FlexBox);

export type Image = {
    url: string;
    title?: string;
};

interface StartingProjectDisplayProps {
    images: Image[] | undefined;
    title?: string;
    description?: string | null;
}

export default function StartingProjectDisplay({
    images,
    title,
    description,
}: StartingProjectDisplayProps) {
    return (
        <ResponsiveCard
            mt={5}
            p={4}
            style={{
                borderRadius: tokensRaw.SwanSemBorderRadiusSubtle,
            }}
            swanStyle={{
                backgroundColor: 'info',
            }}
            sm={{
                style: {
                    minWidth: 630,
                    minHeight: 104,
                },
            }}
        >
            <GridContainer>
                <Row>
                    <Column pl={2} span={8}>
                        <Typography fontSkin="title-item">{title}</Typography>
                        <Typography fontSkin="body-small">{description}</Typography>
                    </Column>
                    <Column pr={2} span={4}>
                        <ResponsiveFlexBox
                            style={{ height: '100%', minHeight: '104px' }}
                            alignItems="center"
                            sm={{
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <StartingProjectImages images={images} />
                        </ResponsiveFlexBox>
                    </Column>
                </Row>
            </GridContainer>
        </ResponsiveCard>
    );
}
